"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaleTransactionAttributes$ = exports.SaleTransactionAttributes$outboundSchema = exports.SaleTransactionAttributes$inboundSchema = void 0;
exports.saleTransactionAttributesToJSON = saleTransactionAttributesToJSON;
exports.saleTransactionAttributesFromJSON = saleTransactionAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const addresses_js_1 = require("./addresses.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
const imagetypes_js_1 = require("./imagetypes.js");
const listingtenure_js_1 = require("./listingtenure.js");
const streetview_js_1 = require("./streetview.js");
/** @internal */
exports.SaleTransactionAttributes$inboundSchema = z.object({
    address: z.nullable(addresses_js_1.Addresses$inboundSchema),
    distance_in_metres: z.nullable(z.number().int()),
    images: z.nullable(imagetypes_js_1.ImageTypes$inboundSchema),
    internal_area_square_metres: z.nullable(z.number().int()),
    is_new_build: z.nullable(z.boolean()),
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$inboundSchema),
    number_of_bathrooms: z.nullable(z.number().int()),
    number_of_bedrooms: z.nullable(z.number().int()),
    price: z.nullable(z.number().int()),
    price_per_square_metre: z.nullable(z.number().int()),
    property_type: z.nullable(z.string()),
    street_group_property_id: z.nullable(z.string()),
    street_view: z.nullable(streetview_js_1.StreetView$inboundSchema),
    tenure: z.nullable(listingtenure_js_1.ListingTenure$inboundSchema),
    transaction_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    transaction_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "distance_in_metres": "distanceInMetres",
        "internal_area_square_metres": "internalAreaSquareMetres",
        "is_new_build": "isNewBuild",
        "number_of_bathrooms": "numberOfBathrooms",
        "number_of_bedrooms": "numberOfBedrooms",
        "price_per_square_metre": "pricePerSquareMetre",
        "property_type": "propertyType",
        "street_group_property_id": "streetGroupPropertyId",
        "street_view": "streetView",
        "transaction_date": "transactionDate",
        "transaction_id": "transactionId",
    });
});
/** @internal */
exports.SaleTransactionAttributes$outboundSchema = z.object({
    address: z.nullable(addresses_js_1.Addresses$outboundSchema),
    distanceInMetres: z.nullable(z.number().int()),
    images: z.nullable(imagetypes_js_1.ImageTypes$outboundSchema),
    internalAreaSquareMetres: z.nullable(z.number().int()),
    isNewBuild: z.nullable(z.boolean()),
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$outboundSchema),
    numberOfBathrooms: z.nullable(z.number().int()),
    numberOfBedrooms: z.nullable(z.number().int()),
    price: z.nullable(z.number().int()),
    pricePerSquareMetre: z.nullable(z.number().int()),
    propertyType: z.nullable(z.string()),
    streetGroupPropertyId: z.nullable(z.string()),
    streetView: z.nullable(streetview_js_1.StreetView$outboundSchema),
    tenure: z.nullable(listingtenure_js_1.ListingTenure$outboundSchema),
    transactionDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    transactionId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        distanceInMetres: "distance_in_metres",
        internalAreaSquareMetres: "internal_area_square_metres",
        isNewBuild: "is_new_build",
        numberOfBathrooms: "number_of_bathrooms",
        numberOfBedrooms: "number_of_bedrooms",
        pricePerSquareMetre: "price_per_square_metre",
        propertyType: "property_type",
        streetGroupPropertyId: "street_group_property_id",
        streetView: "street_view",
        transactionDate: "transaction_date",
        transactionId: "transaction_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SaleTransactionAttributes$;
(function (SaleTransactionAttributes$) {
    /** @deprecated use `SaleTransactionAttributes$inboundSchema` instead. */
    SaleTransactionAttributes$.inboundSchema = exports.SaleTransactionAttributes$inboundSchema;
    /** @deprecated use `SaleTransactionAttributes$outboundSchema` instead. */
    SaleTransactionAttributes$.outboundSchema = exports.SaleTransactionAttributes$outboundSchema;
})(SaleTransactionAttributes$ || (exports.SaleTransactionAttributes$ = SaleTransactionAttributes$ = {}));
function saleTransactionAttributesToJSON(saleTransactionAttributes) {
    return JSON.stringify(exports.SaleTransactionAttributes$outboundSchema.parse(saleTransactionAttributes));
}
function saleTransactionAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SaleTransactionAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SaleTransactionAttributes' from JSON`);
}
//# sourceMappingURL=saletransactionattributes.js.map